<template>
  <div class="bordaappbar">
    <v-data-table dense class="elevation-1 row-pointer" mobile-breakpoint="1" :headers="Header" :items="GridData" :item-class="RowClass" :sort-desc.sync="Pagination.sortDesc" item-key="Id" :options.sync="Pagination" :server-items-length="Pagination.itemsLength" :footer-props="{ itemsPerPageOptions: RowsPerPageItems }" v-on:update:page="Index()" v-on:update:items-per-page="Index()" v-on:update:sort-by="Index()" v-on:update:sort-desc="Index()">
      <template v-slot:top>
        <v-toolbar dense flat>
          <v-text-field  append-icon="mdi-magnify" dense label="Procurar" v-model="Pagination.Filtro.Busca" single-line hide-details @keyup.native.enter="Index()" @click:append="Index" ></v-text-field> &nbsp;&nbsp;
          <v-switch hide-details dense label="Mostrar Inativos" color="primary" v-model="Pagination.Filtro.Inativos" :false-value="false" :true-value="true" @change="Index()"></v-switch>
          <v-spacer></v-spacer>
          <v-btn to="/Sistema/Grupos/Edit/0" color="primary" v-if="CanEdit">Nova <v-icon>mdi-plus</v-icon> </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`item.Tipo`]="{ item }">
        <template v-if="item.FlagGrupoDeController == true"> <v-icon color="warning">mdi-application-array-outline</v-icon> </template>
        <template v-else> <v-icon color="info">mdi-account-group</v-icon> </template>
      </template>

      <template v-slot:[`item.Action`]="{ item }">
        <v-icon @click="Edit(item.Id)" color="teal">mdi-pencil</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Grupos",
  data() {
    return {
      GridData: [],
      Header: [
        { text: "Id", value: "Id", sortable: false },
        { text: "Nome", value: "Nome", sortable: false },
        { text: "Usuário/Controller", value: "Tipo", sortable: false },
        { text: "", value: "Action", sortable: false },
      ],
      RowsPerPageItems: [5, 10, 20, 30, 40, 50, 100, 200],
      Pagination: {
        page: 1,
        itemsPerPage: 100,
        pageCount: 1,
        itemsLength: 0,
        sortBy: ["Nome"],
        sortDesc: [false],
        Filtro: {
          Busca: "",
          Inativos: false,
        },
      },
      showDialogCadastro: false,
      IsPermitted: 0,
      CanEdit: false,
      CanDelete: false,
      AllowAll: false,
      HideEdit: false,
      HideDelete: false,      
    };
  },
  components: {},
  methods: {
    Edit(Id) {
      this.$router.push("/Sistema/Grupos/Edit/".concat(Id));
    },
    Index() {
      axios.post("/api/Sistema/Grupos/Index", this.Pagination).then((response) => {
        this.GridData = response.data.Data;
        this.Pagination = response.data.Pagination;
            this.LoadPermission();

      });
    },
    RowClass(item) {
      if (item.Ativo == false) {
        return "rowdisabled";
      }
    },
    LoadPermission() {
      axios({ method: "get", data: null, url: "/api/Lista/GetAcesso" })
        .then((response) => {
          this.IsPermitted = response.data;
          this.HideEdit = this.$functions.EditPermitted(this.IsPermitted);
          this.CanEdit = Boolean(this.$functions.EditPermitted(this.IsPermitted, 1));
          this.AllowAll = this.$functions.AllowPermitted();
          this.HideDelete = this.$functions.DeletePermitted(this.IsPermitted);
          this.CanDelete = Boolean(this.$functions.DeletePermitted(this.IsPermitted, 1));        })
        .catch((error) => {
          //
        });
    },    
  },
  mounted: function () {
    this.Index();
  },
};
</script>
